<template>
	<div class="appWrapper" data-font-size="10" data-font-size-type="px">
		<aside aria-hidden="true">
			<nav class="navMob">
				<h2 class="sr-only" data-font-size="15" data-font-size-type="px">
					תפריט ניווט ראשי
				</h2>
				<ul
					class="linksContainer"
					id="menu"
					data-font-size="10"
					data-font-size-type="px"
				>
					<li class="linkWrap" data-font-size="10" data-font-size-type="px">
						<a
							class="link"
							href="/אודות/"
							data-font-size="16"
							data-font-size-type="px"
							>אודות</a
						>
					</li>
					<li class="linkWrap" data-font-size="10" data-font-size-type="px">
						<a
							aria-current="page"
							class="link active"
							href="/"
							data-font-size="16"
							data-font-size-type="px"
							>מגמות בשוק הבינוי</a
						>
					</li>
				</ul>
			</nav>
		</aside>
		<div class="mainApp" data-font-size="10" data-font-size-type="px">
			<div class="overlay" data-font-size="10" data-font-size-type="px"></div>
			<div class="personalAreaContainer">
				<div class="personalAreaNav navStyle">
					<span class="nameWelcome">ברכות בכניסה לאיזור האישי שלך</span>
					<div class="innerLinks nav" role="tablist">
						<div class="linkWrap nav-item">
							<a
								v-if="userVerified"
								@click="selectedTab = 'userAddresses'"
								href="#"
								role="tab"
								data-rb-event-key="0"
								aria-selected="true"
								:class="[
									selectedTab === 'userAddresses' ? 'link nav-link active' : '',
									'link nav-link',
								]"
								>רשימת הנכסים לעדכונים</a
							>
						</div>
						<div class="linkWrap nav-item">
							<a
								v-if="$store.state.currentUser != null"
								@click="selectedTab = 'userProfile'"
								href="#"
								role="tab"
								data-rb-event-key="2"
								aria-selected="false"
								:class="[
									selectedTab === 'userProfile' ? 'link nav-link active' : '',
									'link nav-link',
								]"
								>פרופיל אישי</a
							>
						</div>
					</div>
				</div>
			</div>
			<UserAddresses v-show="selectedTab == 'userAddresses'" />
			<UserProfile v-show="selectedTab == 'userProfile'" />
		</div>
	</div>
</template>

<script>
import UserAddresses from "@/components/UserAddresses.vue";
import UserProfile from "@/components/UserProfile.vue";

export default {
	name: "MemberView",
	components: {
		UserAddresses,
		UserProfile,
	},
	data() {
		return {
			selectedTab: "userAddresses",
		};
	},
	mounted() {
		this.$store.state.currentUser = this.decompressBase64Gzip(this.mixin_getCookie('user'));

		// console.log(
		// 	"currentUser from MemberView",
		// 	this.$store.state.currentUser
		// );

		// if user is not Verified, show verify modal
		if (this.$store.state.currentUser != null && !this.$store.state.currentUser.Verified) {
			this.$store.state.userLimitModal = true;
		}
		//console.log('currentUser from MemeberView', this.$store.state.currentUser);
	},
	computed: {
		userVerified() {
			if (this.$store.state.currentUser == null) 
			{
				return false;
			}
			else {
				return this.$store.state.currentUser.Verified;
			}
		}
	}
};
</script>
